export function formatNumToCoin(num: number): string {
  return `$${(num || 0).toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 }) || '$0.00'}`;
}
